import ApiError from '../../../../entities/api-error/ApiError'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestSettings {
    type: DashboardActionTypes.REQUEST_SETTINGS
}

export function requestSettings(): RequestSettings {
    return {
        type: DashboardActionTypes.REQUEST_SETTINGS,
    }
}

export interface RequestSettingsSuccess {
    type: DashboardActionTypes.REQUEST_SETTINGS_SUCCESS
    payload: {
        storeName: string
        refreshInterval: number
        defaultLanguage: string | null
    }
}

export interface RequestSettingsRestartInterval {
    type: DashboardActionTypes.RESTART_INTERVAL
    payload: {
        storeName: string
        refreshInterval: number
        defaultLanguage: string | null
    }
}

export function requestSettingsSuccess({
    storeName,
    refreshInterval,
    defaultLanguage,
}: RequestSettingsSuccess['payload']): RequestSettingsSuccess {
    return {
        type: DashboardActionTypes.REQUEST_SETTINGS_SUCCESS,
        payload: {
            storeName,
            refreshInterval,
            defaultLanguage,
        },
    }
}

export interface RequestSettingsFailure {
    type: DashboardActionTypes.REQUEST_SETTINGS_FAILURE
    payload: {
        error: ApiError
    }
}

export function requestSettingsFailure({
    error,
}: RequestSettingsFailure['payload']): RequestSettingsFailure {
    return {
        type: DashboardActionTypes.REQUEST_SETTINGS_FAILURE,
        payload: {
            error,
        },
    }
}
